module.exports = __webpack_public_path__ + "img/team2.09e00471.jpg";